var map = {
	"./CMS.svg": 133,
	"./Manage_Admin.svg": 2143,
	"./Manage_Roles.svg": 8597,
	"./icon-dashboard.svg": 6510,
	"./setting.svg": 1270,
	"./subscription.svg": 5249,
	"./support.svg": 1703,
	"./test.svg": 834,
	"./user.svg": 1755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6400;